"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVManager = void 0;
var job_observable_1 = require("./job/job-observable");
var extract_poster_job_response_1 = require("./responses/extract-poster-job-response");
var extract_storyboard_job_response_1 = require("./responses/extract-storyboard-job-response");
var packaging_job_response_1 = require("./responses/packaging-job-response");
var transcode_job_response_1 = require("./responses/transcode-job-response");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @doc AVManager
 */
var AVManager = /** @class */ (function () {
    function AVManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        /**
         * @type {string}
         */
        this.baseUrl = "https://" + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + "/_api/av";
    }
    /**
     * Transcode video
     * @param {TranscodeRequest} transcodeRequest
     * @returns {Observable<JobGroup<TranscodeSpecification>>}
     */
    AVManager.prototype.transcodeVideoObservable = function (transcodeRequest) {
        var _this = this;
        return job_observable_1.observeJobGroupCreator(this.configuration, this.httpClient)(function () { return _this.transcodeVideo(transcodeRequest); });
    };
    /**
     * Transcode Video
     * @param {TranscodeRequest} transcodeRequest
     * @returns {Promise<TranscodeJobResponse>}
     */
    AVManager.prototype.transcodeVideo = function (transcodeRequest) {
        var params = __assign({}, transcodeRequest);
        return this.httpClient
            .post(this.apiUrl + "/transcode", params)
            .then(function (response) {
            return new transcode_job_response_1.TranscodeJobResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Extract Poster
     * @param {ExtractPosterRequest} extractPosterRequest
     * @returns {Promise<ExtractPosterJobResponse>}
     */
    AVManager.prototype.extractPoster = function (extractPosterRequest) {
        var params = __assign({}, extractPosterRequest);
        return this.httpClient
            .post(this.apiUrl + "/poster", params)
            .then(function (response) {
            return new extract_poster_job_response_1.ExtractPosterJobResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Extract storyboard
     * @param {ExtractStoryboardRequest} extractStoryboardRequest
     * @returns {Promise<ExtractStoryboardJobResponse>}
     */
    AVManager.prototype.extractStoryboard = function (extractStoryboardRequest) {
        var params = __assign({}, extractStoryboardRequest);
        return this.httpClient
            .post(this.apiUrl + "/storyboard", params)
            .then(function (response) {
            return new extract_storyboard_job_response_1.ExtractStoryboardJobResponse(response.payload);
        })
            .catch(function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Packaging Service
     * @param {params} PackagingParams
     * @returns {Promise<PackagingJobResponse>}
     */
    AVManager.prototype.packageVideo = function (_a) {
        var sources = _a.sources, directory = _a.directory, acl = _a.acl, chunkDuration = _a.chunkDuration, packageType = _a.packageType;
        var params = {
            sources: sources,
            specification: {
                destination: {
                    directory: directory,
                    acl: acl,
                },
                chunkDuration: chunkDuration,
                packageType: packageType,
            },
        };
        return this.httpClient
            .post(this.apiUrl + "/package", params)
            .then(function (response) { return new packaging_job_response_1.PackagingJobResponse(response.payload); });
    };
    return AVManager;
}());
exports.AVManager = AVManager;
//# sourceMappingURL=av-manager.js.map